'use client';
import { generateColorFromName, getInitials } from '@/slw/shared/lib/utils';
import { Avatar, AvatarFallback, AvatarImage } from '@/slw/shared/ui/avatar';

interface GeneratedAvatarProps {
  name: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xs' | 'sm';
  className?: string;
}

const GeneratedAvatar = ({ name, size = 'md', className = '' }: GeneratedAvatarProps) => {
  const backgroundColor = generateColorFromName(name);
  const initials = getInitials(name);

  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    xs: 'w-5 h-5 text-xs font-base',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base',
    xl: 'w-16 h-16 text-lg',
  };

  return (
    <div
      className={`rounded-full flex items-center justify-center text-white 
      font-semibold select-none ${sizeClasses[size]}  ${className}`}
      style={{ backgroundColor }}
      title={name}
    >
      {initials}
    </div>
  );
};

interface ChatBubbleAvatarProps {
  src?: string;
  fallback?: string;
  name: string;
  avatarUrl?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xs';
  className?: string;
}
const sizeClasses = {
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
  lg: 'w-12 h-12',
  xl: 'w-16 h-16',
  xs: 'size-5',
};

export const BubbleAvatar: React.FC<ChatBubbleAvatarProps> = ({ src, fallback, className, name, size = 'md' }) => (
  <Avatar className={`${sizeClasses[size]} ${className}`}>
    {src && <AvatarImage src={src} alt={name} />}
    <AvatarFallback className='p-0 border-0'>
      {fallback ? fallback : <GeneratedAvatar name={name} size={size} />}
    </AvatarFallback>
  </Avatar>
);
